import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
    /** Used in "Free delivery on {dogName}'s first box". Falls back to "your" if missing. */
    dogName?: string;
};

type BenefitItem = {
    bold: string;
    rest: string;
};

/** Green benefit strip inside the brown plan card — free delivery, superfood supplement, money-back guarantee. */
function BenefitStrip({ dogName }: Props) {
    const namePossessive = dogName?.trim() ? `${dogName.trim()}'s` : "your";

    const items: BenefitItem[] = [
        { bold: "Free delivery", rest: `on ${namePossessive} first box` },
        { bold: "Superfood supplement", rest: "in every meal" },
        { bold: "30-day money-back guarantee", rest: "" },
    ];

    return (
        <Box
            sx={{
                bgcolor: QUIZ.color.green,
                borderRadius: { xs: "16px", md: "20px" },
                p: { xs: "16px 18px", md: "22px 28px" },
                mt: { xs: "16px", md: "22px" },
                mb: { xs: "16px", md: "22px" },
                display: "flex",
                flexDirection: "column",
                gap: { xs: "10px", md: "12px" },
            }}
        >
            {items.map((item, i) => (
                <Box
                    key={i}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: "10px", md: "12px" },
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: 18, md: 22 },
                            height: { xs: 18, md: 22 },
                            borderRadius: "50%",
                            bgcolor: QUIZ.color.brown,
                            color: QUIZ.color.green,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            fontSize: { xs: 11, md: 13 },
                            fontWeight: 700,
                        }}
                    >
                        ✓
                    </Box>
                    <Typography
                        sx={{
                            fontFamily: QUIZ.font.body,
                            fontSize: { xs: 13, md: 16 },
                            lineHeight: 1.3,
                            color: QUIZ.color.ink,
                        }}
                    >
                        <span style={{ fontWeight: 800 }}>{item.bold}</span> {item.rest}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}

export default memo(BenefitStrip);